import { c as _c } from "react/compiler-runtime";
import { PrivilegeCouponRow, PrivilegeExcellencyRow, PrivilegeIspRow } from '@/app/lcv/components/sections/calculator/result/privilege-table/rows';
import { CALCULATOR_DATA_TEST } from '@/app/lcv/components/sections/calculator/tracking';
import { type PrivilegeTableProps } from '@/app/lcv/types/calculator';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
export const PrivilegeTable = t0 => {
  const $ = _c(16);
  const {
    title,
    coupon,
    myMember,
    isp
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = createDataAttributes({
      test: `${CALCULATOR_DATA_TEST.calculator}-privilege-table`
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <h3 className="font-noto-bold text-sub-h2 text-gray-900">{title}</h3>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== coupon) {
    t3 = <PrivilegeCouponRow coupon={coupon} />;
    $[3] = coupon;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== myMember) {
    t4 = <PrivilegeExcellencyRow myMember={myMember} />;
    $[5] = myMember;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== isp) {
    t5 = <PrivilegeIspRow isp={isp} />;
    $[7] = isp;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <div className="grid gap-y-10">{t3}{t4}{t5}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t2 || $[14] !== t6) {
    t7 = <div className="where-span:text-inline-wrap rounded-sm bg-white px-2 py-10 text-center" {...t1}><div className="space-y-10">{t2}{t6}</div></div>;
    $[13] = t2;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};